import { StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createPinInputStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      gap: Typography.gap.gap12,
    },
    input: {
      width: Typography.width.width56,
      height: Typography.height.height56,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.pinInputBorder,
      borderRadius: Typography.radius.radius8,
      textAlign: Typography.textAlign.centerAlign,
      fontSize: Typography.fontSize.fontSize20,
      color: theme.pinInputText,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      
    },
    inputBackground: {
      backgroundColor: theme.pinInputBG,
      borderColor: theme.pinInputTextBorder,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    focusedInput: {
      borderColor: theme.pinInputTextBorder,
      borderWidth: Typography.borderWidth.borderWidth2,
    },
    errorInput: {
      width: Typography.width.width56,
      height: Typography.height.height56,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.pinInputErrorBorder,
      borderRadius: Typography.radius.radius4,
      textAlign: Typography.textAlign.centerAlign,
      fontSize: Typography.fontSize.fontSize20,
      color: theme.pinInputErrorText,
      backgroundColor: theme.pinInputErrorBG,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
    },
  });
